import { Typography } from "@material-ui/core";
import {get, isEmpty} from "lodash";
import moment from "moment";
import React from "react";
import {useRecordContext} from "react-admin";

const CustomTimeField = ({ record = {}, source, isDateTime }: any) => {
  const recordContext = useRecordContext();
  const records = isEmpty(record) ? recordContext : record;
  const time = get(records, source);

  return (
    <Typography variant="body2">
      {moment(time, "hh:mm").format("hh:mm A")}
    </Typography>
  );
};

export default CustomTimeField;
